import * as React from 'react';
import { withTranslation, WithTranslation } from "react-i18next";
import './deleteTemplateModule.scss';
import { getTemplate, getDraftNotifications, getScheduledNotifications, deleteTemplate } from '../../apis/messageListApi';
import { RouteComponentProps } from 'react-router-dom';
import * as AdaptiveCards from "adaptivecards";
import { app, dialog } from "@microsoft/teams-js";
import { getScheduledMessagesList, getDraftMessagesList, getAllTemplatesList } from '../../actions';
import { connect } from 'react-redux';
import {
    getInitAdaptiveCard, setTemplateBanner, setTemplateColor, setTemplateElements
} from '../AdaptiveCard/adaptiveCard';
import { TFunction } from "i18next";
import { markDownToHtml } from '../../helpers/formattingHelper'
import { Button, Spinner, Label } from "@fluentui/react-components"


export interface IListItem {
    header: string,
    media: JSX.Element,
}

export interface ITemplate {
    id: string,
    templateName: string,
    bannerUrl: string,
    backgroundColorId: string,
    backgroundColorUrl: string,
    textColor: string,
    authorGroups: string[],
    elements: string[],
    creatorName: string,
}

export interface IDeleteState {
    template: ITemplate;
    loader: boolean;
    draftMessages?: any;
    scheduledMessages?: any;
    draftMessagesFound: boolean;
    scheduledMessagesFound: boolean;
}

interface DeleteTemplateModuleProps extends RouteComponentProps, WithTranslation {
    getScheduledMessagesList?: any;
    getDraftMessagesList?: any;
    getAllTemplatesList?: any;
}

class DeleteTemplateModule extends React.Component<DeleteTemplateModuleProps, IDeleteState> {
    readonly localize: TFunction;
    private initTemplate: ITemplate = {
        id: "",
        templateName: "",
        bannerUrl: "",
        backgroundColorId: "",
        backgroundColorUrl: "",
        textColor: "",
        authorGroups: [],
        elements: [],
        creatorName: "",
    };

    private card: any;

    constructor(props: DeleteTemplateModuleProps) {
        super(props);

        this.localize = this.props.t;

        this.card = getInitAdaptiveCard(this.localize);

        this.state = {
            template: this.initTemplate,
            loader: true,
            draftMessagesFound: false,
            scheduledMessagesFound: false,
        };
    }

    public async componentDidMount() {
        await app.initialize();
        let params = this.props.match.params;

        if ('id' in params) {
            let id = String(params['id']);

            await this.getTemplate(id);
            setTemplateBanner(this.card, this.state.template.bannerUrl);
            setTemplateColor(this.card, this.state.template.backgroundColorUrl);
            setTemplateElements(this.localize, this.card, this.state.template.elements, this.state.template.textColor)

            var draftResponse = await getDraftNotifications();
            var draftsWithTemplate = draftResponse.data.filter((m: any) => m.updateType === this.state.template.id);
            var scheduledResponse = await getScheduledNotifications();
            var scheduledWithTemplate = scheduledResponse.data.filter((m: any) => m.updateType === this.state.template.id);

            this.setState({
                draftMessages: draftsWithTemplate,
                scheduledMessages: scheduledWithTemplate,
                draftMessagesFound: draftsWithTemplate.length !== 0,
                scheduledMessagesFound: scheduledWithTemplate.length !== 0,
                loader: false,
            }, () => {
                let adaptiveCard = new AdaptiveCards.AdaptiveCard();
                AdaptiveCards.AdaptiveCard.onProcessMarkdown = function (text, result) {
                    result.outputHtml = markDownToHtml(text);
                    result.didProcess = true;
                };

                adaptiveCard.parse(this.card);
                let renderedCard = adaptiveCard.render() as HTMLElement;
                var adaptiveCardContainer = document.getElementsByClassName('adaptiveCardContainer')[0];

                if (!!adaptiveCardContainer) {
                    adaptiveCardContainer.appendChild(renderedCard);
                }
            })
        }
    }

    private getTemplate = async (id: string) => {
        try {
            let response = await getTemplate(id);
            const templateData = response.data;

            var newTemplate: ITemplate = {
                id: templateData.id,
                templateName: templateData.templateName,
                bannerUrl: templateData.bannerUrl,
                backgroundColorId: templateData.backgroundColorId,
                backgroundColorUrl: templateData.backgroundColorUrl,
                textColor: templateData.textColor,
                authorGroups: templateData.authorGroups,
                elements: templateData.elements,
                creatorName: templateData.creatorName,
            }
            this.setState({
                template: newTemplate
            });
        } catch (error) {
            return error;
        }
    }

    public render(): JSX.Element {
        if (this.state.loader) {
            return (
                <div className="loader">
                    <Spinner />
                </div>
            );
        } else {
            return (
                <div className="taskModule">
                    <div className="formContainer">
                        <div className="formContentContainer" >
                            <div className="contentField">
                                <h3>{this.localize("TemplateNameText")}</h3>
                                <span>{this.state.template.templateName}</span>
                            </div>
                            <div className="contentField">
                                <h3>{this.localize("CreatedBy")}</h3>
                                <span>{this.state.template.creatorName}</span>
                            </div>
                            <div className="contentField">
                                <h3>{this.localize("DraftMessagesSectionTitle")}</h3>
                                {
                                    this.state.draftMessages.map((m: any) => {
                                        return <label>{m.title ? m.title : "(Empty Title)"}</label>
                                    })
                                }
                                {(!this.state.draftMessagesFound) && (
                                    <Label>0 {this.localize("DraftMessagesSectionTitle")}</Label>
                                )}
                            </div>
                            <div className="contentField">
                                <h3>{this.localize("ScheduledMessagesSectionTitle")}</h3>
                                {
                                    this.state.scheduledMessages.map((m: any) => {
                                        return <label>{m.title ? m.title : "(Empty Title)"}</label>
                                    })
                                }
                                {(!this.state.scheduledMessagesFound) && (
                                    <Label>0 {this.localize("ScheduledMessagesSectionTitle")}</Label>
                                )}
                            </div>
                            <div className="contentField">
                                {(this.state.draftMessagesFound || this.state.scheduledMessagesFound) && (
                                    <Label className="errorField">0 {this.localize("DeleteTemplateErrorText")}</Label>
                                )}
                                {(!this.state.draftMessagesFound && !this.state.scheduledMessagesFound) && (
                                    <Label className="successField">0 {this.localize("DeleteTemplateSuccessText")}</Label>
                                )}
                            </div>
                        </div>
                        <div className="adaptiveCardContainer">
                        </div>
                    </div>
                    <div className="footerContainer">
                        <div className="buttonContainer">
                            <Button id="cancelBtn" onClick={this.onCancel} appearance='primary'>{this.localize("CancelText")}</Button>
                            <Spinner id="deletingLoader" className="hiddenLoader deletingLoader" size="extra-small" label={this.localize("DeletingTemplate")} labelPosition="after" />
                            <Button id="deleteBtn" onClick={this.onDeleteTemplate} appearance='primary' disabled={(this.state.draftMessagesFound || this.state.scheduledMessagesFound)}>{this.localize("DeleteTemplate")}</Button>
                        </div>
                    </div>
                </div>
            );
        }
    }

    private onDeleteTemplate = async () => {
        let spanner = document.getElementsByClassName("deletingLoader");
        spanner[0].classList.remove("hiddenLoader");
        await deleteTemplate(this.state.template.id);
        await this.props.getAllTemplatesList();
        dialog.url.submit();
    }

    private onCancel = () => {
        dialog.url.submit();
    }

    public escFunction(event: any) {
        if (event.keyCode === 27 || (event.key === "Escape")) {
            dialog.url.submit();
        }
    }
}

const mapStateToProps = (state: any) => {
    return {};
}

const StatusTaskModuleWithTranslation = withTranslation()(DeleteTemplateModule);
export default connect(mapStateToProps, { getScheduledMessagesList, getDraftMessagesList, getAllTemplatesList })(StatusTaskModuleWithTranslation);